import { useState, useEffect, useContext } from "react";
import AppHeader from "../../../components/common/appHeader/AppHeader";
import {useNavigate } from "react-router-dom";
import { UserContext } from "./../../../App";
import { autoHypenPhone } from "@src/utils";
import { chkPhoneTel } from "./../../../utils/index";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useRecommendHall } from "../../../utils/hooks/useRecommendHall";
import { postRecommendHall } from "../../../api/recommend/recommend";
import { setCustomer, setCustomerUuid } from "@src/@slice/recommendHallSlice";
import { FormBlock, FormWrap } from "@src/components/form/formBlock/FormBlock";
import InputBox from "@src/components/form/inputBox/base/InputBox";

const CustomerInfo = () => {
  const [validate, setValidate] = useState(true);
  const [loading, setLoading] = useState(false);
  const user = useContext(UserContext);
  const navigate = useNavigate();
  const { hallData, dispatch, isComplete } = useRecommendHall();
  const customer = hallData.customer;
  const postRecommend = () => {
    if (isComplete) {
      alert("이미 신청된 양식입니다.");
      return;
    }
    if (loading) return;
    setLoading(true);
    postRecommendHall({
      ...hallData,
    })
      .then((res) => {
        setLoading(false);
        navigate("/recommend/hall/complete");
      })
      .catch((err) => {
        alert("error!");
        setLoading(false);
        console.log(err);
      });
  };

  const nameCheck = (string) =>{
    const nameRegex = /^[가-힣a-zA-Z\s]{2,}$/;
    return nameRegex.test(string)
  }
  useEffect(() => {
    if (
      hallData.hallStyleTypes.length === 0 ||
      hallData.weddingType === "" ||
      hallData.weddingRegions.length === 0 ||
      (hallData.expectedPerson.min === null && hallData.expectedPerson.max === null) ||
      hallData.meal.types.length === 0 ||
      (hallData.meal.minPrice === null && hallData.meal.maxPrice === null) ||
      hallData.hopeWedding.yearMonths.length === 0 ||
      hallData.hopeWedding.days.length === 0 ||
      hallData.hopeWedding.times.length === 0 //||
      // hallData.tourHopedSchedule === ""
    ) {
      // navigate("/recommend/hall/start", { replace: true });
    }
  }, []);
  useEffect(() => {
    const customer = hallData.customer;
    if (
      customer.tel.trim() === "" ||
      customer.name.trim() === "" ||
      customer.mateTel.trim() === "" ||
      customer.mateName.trim() === "" ||
      !chkPhoneTel(customer.tel,'PHONE') ||
      !chkPhoneTel(customer.mateTel,'PHONE') ||
      !nameCheck(customer.name) ||
      !nameCheck(customer.mateName)
    ) {
      setValidate(false);
    } else {
      setValidate(true);
    }
  }, [hallData.customer]);
  useEffect(() => {
    if (isComplete) {
      window.location.href = "h2mwbell://webview/close";
    }
    if (user.me) {
      dispatch(setCustomerUuid({ uuid: user.me.uuid }));
      if (user.me.sex && customer.role === "") {
        dispatch(setCustomer({ key: "role", data: user.me.sex === 1 ? "BRIDE" : "GROOM" }));
      }
      if (user.me.customerName && customer.name === "") {
        dispatch(setCustomer({ key: "name", data: user.me.customerName }));
      }
      if (user.me.tel) {
        dispatch(setCustomer({ key: "tel", data: user.me.tel }));
      }
      if (user.me.mateTel && customer.mateTel === "") {
        dispatch(setCustomer({ key: "mateTel", data: user.me.mateTel }));
      }
      if (user.me.mateName && customer.mateName === "") {
        dispatch(setCustomer({ key: "mateName", data: user.me.mateName }));
      }
    }
  }, [user.me]);

  return (
    <div>
      <AppHeader type="stack" actionItems={[{ name: "close" }]} />
      <PageTitle title={`신청자 정보를 확인해주세요.`}/>
      <div className="common-wrap">
        <FormWrap>
          <FormBlock
            title=""
            typeStr=""
            content={
              <ul className="my-role-list-wrap">
                <li
                  className={customer.role === "BRIDE" ? "on" : ""}
                  onClick={() => dispatch(setCustomer({ key: "role", data: "BRIDE" }))}
                >
                  신부
                </li>
                <li
                  className={customer.role === "GROOM" ? "on" : ""}
                  onClick={() => dispatch(setCustomer({ key: "role", data: "GROOM" }))}
                >
                  신랑
                </li>
              </ul>
            }
          />
          <FormBlock
            title="이름"
            typeStr=""
            content={
              <InputBox
                type="text"
                className="input-text input-full"
                placeholder="이름"
                value={customer.name}
                showHelpTextError={customer.name !== '' && !nameCheck(customer.name)} 
								showErrorBorder={customer.name !== '' && !nameCheck(customer.name)}
                onChange={(e) => dispatch(setCustomer({ key: "name", data: e.target.value }))}
                resultObj={{
                  result: "error",
                  message: "올바른 이름을 입력해주세요."
                }}
              />
            }
          />
          <FormBlock
            title="전화번호"
            typeStr=""
            content={
              <InputBox
                type="tel"
                className="input-text input-full"
                placeholder="01012345678"
                defaultValue={autoHypenPhone(customer.tel)}
                value={autoHypenPhone(customer.tel)}
                onChange={(e) => {
                  const tel = autoHypenPhone(e.target.value);
                  dispatch(setCustomer({ key: "tel", data: tel }));
                }}
                onKeyDown={(e) => {
                  if (e.key.toLowerCase() !== "backspace" && customer.tel.length >= 13) {
                    e.preventDefault();
                  }
                }}
                // onBlur={() => checkInputValidOnBlur('tel')}
                showHelpTextError={customer.tel.trim() !== "" && !chkPhoneTel(customer.tel,'PHONE')} 
                showErrorBorder={customer.tel.trim() !== "" && !chkPhoneTel(customer.tel,'PHONE')}
                resultObj={{
                  result: "error",
                  message: "올바른 전화번호를 입력해주세요."
                }}
              />
            }
          />
          <FormBlock
            title="배우자 이름"
            typeStr=""
            content={
              <InputBox
              type="text"
              className="input-text input-full"
              placeholder="예비 배우자 이름"
              value={customer.mateName}
              showHelpTextError={customer.mateName !== '' && !nameCheck(customer.mateName)} 
              showErrorBorder={customer.mateName !== '' && !nameCheck(customer.mateName)}
              onChange={(e) => dispatch(setCustomer({ key: "mateName", data: e.target.value }))}
              resultObj={{
                result: "error",
                message: "올바른 이름을 입력해주세요."
              }}
            />
            }
          />
          <FormBlock
            title="배우자 전화번호"
            typeStr=""
            content={
              <InputBox
                type="tel"
                className="input-text input-full"
                placeholder="01012345678"
                defaultValue={autoHypenPhone(customer.mateTel)}
                value={autoHypenPhone(customer.mateTel)}
                onChange={(e) => {
                  const tel = autoHypenPhone(e.target.value);
                  dispatch(setCustomer({ key: "mateTel", data: tel }));
                }}
                onKeyDown={(e) => {
                  if (e.key.toLowerCase() !== "backspace" && customer.mateTel.length >= 13) {
                    e.preventDefault();
                  }
                }}
                // onBlur={() => checkInputValidOnBlur('tel')}
                showHelpTextError={customer.mateTel.trim() !== "" && !chkPhoneTel(customer.mateTel,'PHONE')} 
                showErrorBorder={customer.mateTel.trim() !== "" && !chkPhoneTel(customer.mateTel,'PHONE')}
                resultObj={{
                  result: "error",
                  message: "올바른 전화번호를 입력해주세요."
                }}
              />
            }
          />
        </FormWrap>
      </div>
      <div style={{ height: 20 }}></div>
      <div className="btn-wrap">
        <button
          disabled={!validate}
          className={`btn btn-giant btn-full btn-red500 ${!validate ? "btn-disabled" : ""}`}
          onClick={postRecommend}
        >
          완료
        </button>
      </div>
    </div>
  );
};

export default CustomerInfo;
